$(document).ready(function() {
    $('#portalsAiDataRequestsPersonalInfoChecked').click(function() {
        let checkbox = $(this)
        let submitWithSignButton = $('#portalsTicketsSubmitWithSignButton')
        let submitButton = $('#portalsTicketsSubmitButton')

        if(checkbox.is(':checked')){
            submitWithSignButton.attr("disabled", false);
            submitButton.attr("disabled", false);
        } else{
            submitWithSignButton.attr("disabled", true);
            submitButton.attr("disabled", true);
        }
    });
});
